import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import useStore from '../store/useStore';

const RefreshDialog = () => {
  const { refreshDialogOpen, logout } = useStore();

  const handleRefresh = () => {
    // 确保清除用户数据后再刷新，防止用过期token自动登录
    logout();
    window.location.reload();
  };

  return (
    <Dialog
      open={refreshDialogOpen}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        // 禁止点击背景关闭
        if (reason === 'backdropClick') {
          return;
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: '350px'
        }
      }}
    >
      <DialogTitle sx={{ 
        textAlign: 'center',
        pb: 1,
        pt: 3
      }}>
        <RefreshIcon sx={{ 
          fontSize: 64, 
          color: 'warning.main',
          mb: 2
        }} />
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
          Session Expired
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ textAlign: 'center', px: 3, pb: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Your session has expired. Please refresh the page to continue.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          variant="contained"
          size="large"
          onClick={handleRefresh}
          startIcon={<RefreshIcon />}
          sx={{
            px: 4,
            backgroundColor: 'var(--gold)',
            color: 'var(--night)',
            '&:hover': {
              backgroundColor: 'var(--goldSoft)'
            }
          }}
        >
          Refresh Page
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshDialog;